import React, { MouseEvent } from 'react';

import Button from '../../../../../common/button/Button';
import Modal from '../../../../../common/modal/Modal';

import '../team-modals.scss';

type Props = {
  show: boolean;
  close: (event: MouseEvent<HTMLButtonElement>) => void;
  onDeleteClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

const RemoveTeamMemberModal = ({ show, close, onDeleteClick }: Props) => (
  <Modal show={show}>
    <section className="team-modals">
      <h1 className="team-modals__header">Remove Member</h1>
      <p className="team-modals__message">
        Removing the member from the team will also remove all the member's points from the team!{' '}
      </p>
      <div className="team-modals__button-container">
        <Button text="Cancel" onClick={close} />
        <Button text="Remove Member" onClick={onDeleteClick} />
      </div>
    </section>
  </Modal>
);

export default RemoveTeamMemberModal;
